export const formatPrice = (
  price: number | null | undefined,
  market: Intl.LocalesArgument,
  currency: string
): string => {
  if (price === null || price === undefined) {
    return "";
  }

  const priceNum = Number(price);

  const withoutCents = Intl.NumberFormat(market, {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(priceNum);

  const withCents = Intl.NumberFormat(market, {
    style: "currency",
    currency,
    minimumFractionDigits: 2
  }).format(priceNum);

  return price % 1 === 0 ? withoutCents : withCents;
};
